
<script>
	import { TYPES, TIMER_LENGTHS } from '../utils/constants';

	export let game;

	let timerText = '';
	$: if (game.timerLength === TIMER_LENGTHS.noTimer) {
		timerText = 'No Timer';
	}
	else if (game.timerLength === TIMER_LENGTHS.default) {
		timerText = 'Default Timer';
	}
	else if (game.timerLength === TIMER_LENGTHS.slow) {
		timerText = 'More Time';
	}
	else if (game.timerLength === TIMER_LENGTHS.slower) {
		timerText = 'Too Much Time';
	}
</script>

<p class="settings">
	{#if game.type === TYPES.pub}
		<span class="setting">
			4-{game.numPlayersRequired} players
		</span>
		<span class="setting">
			{timerText}
		</span>
	{:else}
		<span class="setting">
			{game.mnemonic}
		</span>
		<span class="setting">
			{timerText}
		</span>
	{/if}
</p>

<style lang="less">
	.settings {
		white-space: nowrap;
		text-align: center;

		.setting {
			display: inline-block;
			padding: 1.5em 1em;
			margin: 0.25em;
			font-size: 0.8em;
			text-align: center;
			color: white;
			background: #18d72e;
			border: 0.1em solid white;
			border-radius: 2.3rem;
			box-shadow: 0 0 2em rgba(24, 215, 46, 0.5);
			user-select: none; -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none;
		}
	}
</style>
